import { render, staticRenderFns } from "./XwPopoVer.vue?vue&type=template&id=1235a84e"
import script from "./XwPopoVer.vue?vue&type=script&lang=js"
export * from "./XwPopoVer.vue?vue&type=script&lang=js"
import style0 from "./XwPopoVer.vue?vue&type=style&index=0&id=1235a84e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports